<template>
  <a-modal
    v-model:open="visible"
    :width="width"
    :height="height"
    wrapClassName="ppt-order-modal"
    :footer="null"
    destroy-on-close
    :mask-closable="true"
    @cancel="onClose"
  >
    <div class="title">
      <iconpark-icon v-if="icon" name="circle-check" class="text-success" />
      {{ title }}
    </div>
    <div class="mt-[16px]">
      <slot name="content"></slot>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
const props = defineProps<{
  width: number;
  height: number;
  title: string;
  icon?: boolean;
}>();

const $emit = defineEmits(['close']);

const visible = ref(false);

const toggleShow = () => {
  visible.value = !visible.value;
};

const onClose = () => {
  visible.value = false;
  $emit('close');
};

defineExpose({
  toggle: toggleShow,
});
</script>

<style lang="scss">
.ppt-order-modal {
  .ant-modal-content {
    padding: 20px;
    padding-top: 15px;
    background: linear-gradient(180deg, #dddcff 0%, #f6f8f9 100%);
  }
  .ant-modal-close {
    top: 22px;
  }
  .title {
    @apply text-[24px] text-center text-font-1 flex-y-center justify-center gap-[12px];
    font-weight: 600;
    background: linear-gradient(117deg, #5625ff 0%, #121926 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
